import type {
  Action,
  SagaCallbacks,
} from '../types';

import * as actionTypes from './actionTypes';

export const requestProgram = (
  id: number,
  resourceType: string,
): Action => ({
  type: actionTypes.REQUEST_PROGRAM,
  id,
  resourceType,
});

export const requestProgramWeeks = (
  id: number,
  resourceType: string,
): Action => ({
  type: actionTypes.REQUEST_PROGRAM_WEEKS,
  id,
  resourceType,
});

export const requestProgramWorkouts = (
  id: number,
  resourceType: string,
): Action => ({
  type: actionTypes.REQUEST_PROGRAM_WORKOUTS,
  id,
  resourceType,
});

export const requestProgramAssignments = (
  id: number,
  resourceType: string,
): Action => ({
  type: actionTypes.REQUEST_PROGRAM_ASSIGNMENTS,
  id,
  resourceType,
});

export const requestAddProgramWeek = ({
  programId,
  programType,
}: {
  programId: number,
  programType: string,
}): Action => ({
  type: actionTypes.REQUEST_ADD_PROGRAM_WEEK,
  programId,
  programType,
});

export const requestAddProgramWorkout = ({
  payload,
  callbacks,
}: {
  payload: any,
  callbacks?: SagaCallbacks,
}): Action => ({
  type: actionTypes.REQUEST_ADD_PROGRAM_WORKOUT,
  payload,
  callbacks,
});

export const requestDuplicatePersonalProgramWorkout = ({
  id,
  payload,
  callbacks,
} : {
  id: number,
  payload: any,
  callbacks?: SagaCallbacks,
}): Action => ({
  type: actionTypes.REQUEST_DUPLICATE_PERSONAL_PROGRAM_WORKOUT,
  id,
  payload,
  callbacks,
});

export const requestCopyProgramWeek = ({
  week,
  programId,
  programType,
}: {
  week: number,
  position: number,
  programId: number,
}): Action => ({
  type: actionTypes.REQUEST_COPY_PROGRAM_WEEK,
  week,
  programId,
  programType,
});
